import { withInstall } from '@hd-front-end/utils'
import Statistic from './src/statistic.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElStatistic: SFCWithInstall<typeof Statistic> =
  withInstall(Statistic)

export default ElStatistic
export * from './src/statistic'
